import globalConfig from '../../utiles/globalConfig';
import { getJSON, PASSPORT_HOST, post, STORE_HOST } from '../ultile';
import getStoreLan from './languages';
import languages from '../languages';
import {
  storeLocation,
  storePayTypeList,
  storeProductList,
  setDefaultPayType,
  setLastedPayType,
  storeServerId,
  storeServerName,
  storeCoinName,
  getStoreHrefParam,
  storeCurLocation,
  getCurLocation,
  storeProductId,
  getLocaLclStor,
  storeCpProductId,
  setCreditCardRecord,
  getCreditCardRecord,
  setPaypalAgreementRecord,
  getPaypalAgreementRecord,
  storeClientInfo,
  getClientInfo,
  storeCoinTypeInfo,
  getCoinTypeInfo,
  storeAreaLimitInfo
} from './storager';
import coupon from './coupon';
import { gameIdTransform } from '../web/webStore';
import { filterGamCurrencyPayType, filterLocal } from '../config/currencyEnter';
import { PAGE_TYPE_IS_PACKAGE_GAME } from '@configs/officialWebStore/globalGameInfoConfig';
languages.init();
const HTTP = 'https:';
const CHECK_LOGIN = 'center/ajax/get_store_user_json';
export const JUDGE_IS_LOGIN = 'judge_is_login';
export const UPDATE_LOGIN_TYPE = 'update_login_type';
export const LOAD_INIT_DATA = 'loadStoreInitData';
export const RELOAD_WAY = 'reloadPayWay';
export const SET_PAY_TYPES = 'setPayType';
export const POST_ORDER = 'postOrder';
const LOAD_JS = 'loadJs';
const INIT_ACTION = 'init_data';
const RELOAD_WAY_ACTION = 'get_piece_list';
const SET_INIT_DATA = 'setStoreInitData';
export const LOAD_BANK_PRICES = 'load_bank_prices';
const LOAD_BANK_PRICES_URL = 'show_product';
export const GET_INVOICE = 'get_invoice';
const GET_INVOICE_URL = 'virtual_account/get_invoice';
export const DELETE_CARD = 'deleteCard';
export const UPDATE_GAMEID = 'update_gameid';
export const UPDATE_HIDE_SUBMIT = 'update_hide_submit';
export const SET_CREDIT_CARD = 'set_credit_card';
export const GET_CARD_SCHEMES_ACTION = 'get_card_schemes_action';
export const TOGGLE_PAYPAL_AGREEMENT = 'toggle_paypal_agreement';
export const GET_THIRD_PARTY_PRODUCT_ID = 'get_third_party_product_id';
export const UPDATE_COIN_TYPE_INFO = 'update_coin_type_info';
export const MODIFY_THIRD_PARTY_PAYMENT_INFOS = 'modify_third_party_payment_infos'; // 修改用户第三方支付信息
export const MODIFY_AREA_LIMIT_INFO = 'modify_area_limit_info'; // 修改地区限制数据
export const UPDATE_AREA_LIMIT_INFO = 'update_area_limit_info'; // 更新地区限制信息
export const GET_LOCATION_CURRENCY_LIST = 'get_location_currency_list'; // 获取支付地区可用币种
export const GET_ZIP_CODE_LIST = 'get_zip_code_list'; // 获取ZipCode列表
export const GET_VAT = 'get_vat'; // 获取税费
export const MODIFY_ZIPCODE = 'modify_zipcode'; // 修改ZipCode

export const COIN_TYPE = 0; // 游戏币类型
export const VOUCHER_TYPE = 1; // 代金币类型

const clientInfo = getClientInfo();
const SET_CREDIT_CARD_LIST = 'set_credit_card_list';
const currentPaypalAgreement = getPaypalAgreementRecord() || false;
let formatLocation = function (allLocation) {
  let locations = [];
  // eslint-disable-next-line no-unused-vars
  for (let value in allLocation) {
    let name = allLocation[value];
    let locationObj = {
      name,
      value
    };
    locations.push(locationObj);
  }
  return locations;
};

// 旧储值页过滤掉平台币渠道
const filterUserBalance = payTypeList => {
  if (payTypeList && payTypeList.filter) {
    return payTypeList.filter(item => {
      return item?.f_pay_type !== 'user_balance_pay';
    });
  } else {
    return payTypeList;
  }
};

function specialHandleFilterPayType(params, data) {
  // 特殊处理：隐藏390这个游戏的部分渠道 => https://www.tapd.cn/67637487/prong/stories/view/1167637487001242236
  if (+params?.gameId === 390 && data?.paytype_list) {
    const pay_type_arr = ['RU-CARD', 'RU-NET_BANKING-SBERBANK', 'RU-NET_BANKING-TINKOFFBANK', 'RU-BANK_TRANSFER-SBP'];
    data.paytype_list = data.paytype_list?.filter?.(item => {
      return !(item?.f_pay_type === 'payer_max' && pay_type_arr.includes(item?.pay_type));
    }) || data.paytype_list;
  }
  return data;
}

export default {
  state: {
    config: '',
    locations: [],
    curLocation: getCurLocation() || '',
    coin_name: '',
    loginType: '',
    max_extra_ratio: '',
    is_dai_chong: false,
    allLocations: getLocaLclStor(),
    languages: getStoreLan(),
    letter: languages.getAll(),
    bankPricesData: '',
    uid:
      globalConfig.getLclStorageItem('lid') ||
      globalConfig.getLclStorageItem('userId') ||
      '',
    gameId: '',
    hideSubmit: false,
    creditCardList: [], // 信用卡列表
    creditCard: '', // 信用卡支付方式
    white: clientInfo?.white || '0', // 是否是白名单
    security: clientInfo?.security || '0', // 是否是安全登陆
    clientId: clientInfo?.clientId || '', // 客户端唯一id
    paypalAgreement: currentPaypalAgreement, // Paypal快捷支付勾选状态

    coinName: '', //游戏币名称
    voucherCoinName: '', //代金币名称
    subCoinType: 0, //拆单内容类型，0：游戏币，1：代金币
    extraCoinType: 0, //加码内容类型，0：游戏币，1：代金币
    directPayCoinType: 0, //汇款内容类型，0：游戏币，1：代金币
    directPayExtraCoinType: 0, //汇款加码内容类型，0：游戏币，1：代金币
    ipZipCode: '', // 美国ip地区zipCode
    zipCode: '', // 美国地区zipCode
    locationModifyCount: 0, // 地区修改次数
    maxLocationModifyCount: 0, // 地区修改最大次数
    ipLocation: '' // ip地区
  },
  mutations: {
    [UPDATE_HIDE_SUBMIT](state, bool) {
      state.hideSubmit = bool;
    },
    [UPDATE_GAMEID](state, gameid) {
      state.gameId = gameid;
    },
    [SET_INIT_DATA](state, data) {
      state.config = data;
      state.locations = formatLocation(data.all_locations);
      state.curLocation = data.current_location;
      state.coin_name = data.coin_name;

      state.coinName = data.coin_name;
      state.voucherCoinName = data.voucher_coin_name;
      state.subCoinType = data.sub_coin_type;
      state.extraCoinType = data.extra_coin_type;
      state.directPayCoinType = data.direct_pay_coin_type;
      state.directPayExtraCoinType = data.direct_pay_extra_coin_type;

      state.max_extra_ratio = data.max_extra_ratio;
      state.white = data.white;
      state.security = data.security;
      state.clientId = data.client_id;
      state.is_dai_chong = !!(
        data.ext_info && data.ext_info.show_pay_tips == 1
      );

      state.ipZipCode = data?.ip_zip_code || '';
      state.zipCode = data?.zip_code || '';
      state.locationModifyCount = data?.location_modify_count || 0;
      state.maxLocationModifyCount = data?.max_location_modify_count || 0;
      state.ipLocation = data?.ip_location;
      state.defaultCurrency = data?.default_currency;

      storeAreaLimitInfo({
        ipZipCode: data?.ip_zip_code,
        zipCode: data?.zip_code,
        locationModifyCount: data?.location_modify_count,
        maxLocationModifyCount: data?.max_location_modify_count,
        ipLocation: data?.ip_location,
        defaultCurrency: data?.default_currency
      });
      // 赋空用户切换id
      const filterPayTypeList = filterUserBalance(data.paytype_list);
      storeProductId('');
      storeCpProductId(data.cp_product_id);
      storeCurLocation(data.current_location);
      storeLocation(state.locations);
      storePayTypeList(filterPayTypeList);
      storeProductList(data.product_list);
      setLastedPayType(data?.paytype);
      setDefaultPayType(data?.paytype || filterPayTypeList[0]);
      storeServerId(data.server_id);
      storeServerName(data.server_name);
      storeCoinName(data.coin_name);
      storeClientInfo({
        white: data.white,
        security: data.security,
        clientId: data.client_id
      });
      storeCoinTypeInfo({
        coinName: data.coin_name,
        voucherCoinName: data.voucher_coin_name,
        subCoinType: data.sub_coin_type,
        extraCoinType: data.extra_coin_type,
        directPayCoinType: data.direct_pay_coin_type,
        directPayExtraCoinType: data.direct_pay_extra_coin_type
      });
      state.allLocations = getLocaLclStor();
      // this.commit(UPDATE_COUPON_LIST,data)
    },
    // 更新登录方式
    [UPDATE_LOGIN_TYPE](state, loginType) {
      state.loginType = loginType;
    },
    [SET_PAY_TYPES](state, payType) {
      state.curPayType = payType;
    },
    [SET_PAY_TYPES](state, payType) {
      state.curPayType = payType;
    },
    [LOAD_BANK_PRICES](state, bankPricesData) {
      state.bankPricesData = bankPricesData;
    },
    [SET_CREDIT_CARD_LIST](state, list) {
      state.creditCardList = list;
    },
    [SET_CREDIT_CARD](state, card) {
      state.creditCard = card;
      setCreditCardRecord(card);
    },
    [TOGGLE_PAYPAL_AGREEMENT](state) {
      state.paypalAgreement = !state.paypalAgreement;
      setPaypalAgreementRecord(state.paypalAgreement);
    },
    [UPDATE_COIN_TYPE_INFO](state, info) {
      state.coinName = info?.coinName || '';
      state.voucherCoinName = info?.voucherCoinName || '';
      state.subCoinType = info?.subCoinType || 0;
      state.extraCoinType = info?.extraCoinType || 0;
      state.directPayCoinType = info?.directPayCoinType || 0;
      state.directPayExtraCoinType = info?.directPayExtraCoinType || 0;
    },
    // 修改地区次数
    [MODIFY_AREA_LIMIT_INFO](state, info) {
      if (!info.force) {
        state.locationModifyCount += 1;
      }
      state.curLocation = info.location_code;
      state.zipCode = info.zip_code;
      state.defaultCurrency = info.default_currency;
      storeAreaLimitInfo({
        ipZipCode: state.ipZipCode,
        zipCode: info.zip_code,
        locationModifyCount: state.locationModifyCount,
        maxLocationModifyCount: state.maxLocationModifyCount,
        ipLocation: state.ipLocation,
        defaultCurrency: info.default_currency
      });
    },
    [UPDATE_AREA_LIMIT_INFO](state, info) {
      state.zipCode = info.zipCode;
      state.locationModifyCount = info.locationModifyCount;
      state.maxLocationModifyCount = info.maxLocationModifyCount;
      state.ipLocation = info.ipLocation;
      state.defaultCurrency = info.defaultCurrency;
    },
    // 修改zipcode
    [MODIFY_ZIPCODE](state, zipcode) {
      state.zipCode = zipcode;
    }
  },
  getters: {
    // 拆单内容名称
    subCoinNama: state => {
      return +state.subCoinType === VOUCHER_TYPE
        ? state.voucherCoinName
        : state.coinName;
    },
    // 加码内容名称
    extraCoinName: state => {
      return +state.extraCoinType === VOUCHER_TYPE
        ? state.voucherCoinName
        : state.coinName;
    },
    // 汇款内容名称
    directPayCoinName: state => {
      return +state.directPayCoinType === VOUCHER_TYPE
        ? state.voucherCoinName
        : state.coinName;
    },
    // 汇款加码内容名称
    directPayExtraCoinName: state => {
      return +state.directPayExtraCoinType === VOUCHER_TYPE
        ? state.voucherCoinName
        : state.coinName;
    }
  },
  actions: {
    // 检查登录态
    [JUDGE_IS_LOGIN]({ commit }) {
      return new Promise((resolve, reject) => {
        getJSON(HTTP + PASSPORT_HOST + CHECK_LOGIN, {}).then(res => {
          if (parseInt(res.res.result, 10) === 1) {
            // 针对 2（补款） | 3（大R支付）时，跳转到新版页面
            const loginType = res.res.data.LOGIN_TYPE || '';
            if ([2, 3].includes(loginType)) {
              // 跳转新版登录页
              // 获取当前的url与参数
              const search = window.location.search;
              const params = new URLSearchParams(search);
              if (params.has('isFromGs')) {
                // 存在则覆盖
                params.set('isFromGs', loginType == 3 ? '1' : '0');
              } else {
                  // 不存在则添加
                  params.append('isFromGs', loginType == 3 ? '1' : '0');
              }
              // 获取当前的MAINHOST
              const mainHost = globalConfig.getMainHost();
              if (loginType == 3){
                // 大R支付的话清除登录态
                dispatch(LOGOUT).then(() => {
                  window.location.href = `https://pay.${mainHost}/platform/officialTopupSupplement.html?${params}`;
                });
              } else {
                // 补款的话直接跳转补款页
                window.location.href = `https://pay.${mainHost}/platform/officialTopupSupplement.html?${params}`;
              }
            }
            commit(
              UPDATE_LOGIN_TYPE,
              res.res.data.LOGIN_TYPE ? res.res.data.LOGIN_TYPE : ''
            );
          }
          resolve(parseInt(res.res.result, 10) === 1);
        });
      });
    },
    [LOAD_INIT_DATA]({ commit, dispatch, state }) {
      let params = getStoreHrefParam();
      params['timeStamp'] = '1234';
      params['user_id_cross'] = state.uid || '';
      return new Promise(resolve => {
        getJSON(STORE_HOST + INIT_ACTION, gameIdTransform(params)).then(
          ({ errmsg, data }) => {
            if (!errmsg) {
              data = specialHandleFilterPayType(params, data);
              // 過濾代金幣渠道（這裡暫時沒有處理gameId轉換）
              data.paytype_list = filterGamCurrencyPayType(
                data.paytype_list,
                params.gameId,
                data.current_location
              );
              data.all_locations = filterLocal(
                data.all_locations,
                params.gameId,
                data.current_location
              );
              commit(SET_INIT_DATA, data);
              if (data.scripts && data.scripts.fingerprint_url) {
                dispatch(LOAD_JS, data.scripts.fingerprint_url);
              }
              // 加载Paypal风控 需分别注入两个脚本,参考：https://developer.paypal.com/limited-release/fraudnet/integrate/
              // 前置脚本
              const scriptPre = document.createElement('script');
              scriptPre.type = 'application/json';
              scriptPre.setAttribute(
                'fncls',
                'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99'
              );
              const jsonText = {
                f: data.client_id,
                s: data.sandbox
                  ? 'GMEI_U2JRV7KXL7T9W'
                  : `GMEI_${data.game_id}_WJUQADPG5BZ7G_RT`,
                sandbox: +data.sandbox
              };
              scriptPre.textContent = JSON.stringify(jsonText);
              document.body.appendChild(scriptPre);
              // paypal脚本
              const scriptAfter = document.createElement('script');
              scriptAfter.type = 'text/javascript';
              scriptAfter.src = 'https://c.paypal.com/da/r/fb.js';
              document.body.appendChild(scriptAfter);
              resolve(true);
            } else {
              resolve(false);
            }
          }
        );
      });
    },
    [GET_THIRD_PARTY_PRODUCT_ID]({ _commit }, data) {
      let params = getStoreHrefParam();
      const requestParams = Object.assign(params || {}, data, {
        f_pay_type: 'google_play',
        product_id: params['productId'],
        game_id: params['gameId']
      });
      // 20240321 侏罗纪军团331因为pageType是package，需要添加参数target_product_type=package才能获取到product_id
      const reallyRequestParams = PAGE_TYPE_IS_PACKAGE_GAME.includes(+params.gameId) ? { target_product_type: 'package', ...requestParams } : requestParams;
      const ACTION = 'ajax/' + GET_THIRD_PARTY_PRODUCT_ID;
      return new Promise(resolve => {
        getJSON(STORE_HOST + ACTION, gameIdTransform(reallyRequestParams)).then(
          ({ errmsg, res }) => {
            if (!errmsg) {
              resolve(res);
            } else {
              resolve(false);
            }
          }
        );
      });
    },
    [RELOAD_WAY]({ commit, dispatch }, params = {}) {
      return new Promise((resolve, reject) => {
        let param = getStoreHrefParam();
        param = { ...param, ...params };
        getJSON(STORE_HOST + RELOAD_WAY_ACTION, gameIdTransform(param)).then(
          ({ errmsg, data }) => {
            if (!errmsg) {
              data = specialHandleFilterPayType(param, data);
              const filterPayTypeList = filterUserBalance(data.paytype_list);
              storePayTypeList(filterPayTypeList);
              setDefaultPayType(filterPayTypeList[0]);
              resolve(true);
            } else {
              reject(errmsg);
            }
          }
        );
      });
    },

    [POST_ORDER]({ state }, params) {
      return new Promise((resolve, reject) => {
        const ACTION = params?.f_pay_type + '/submit';
        params['user_id_cross'] = state.uid || '';
        post(STORE_HOST + ACTION, gameIdTransform(params)).then(
          ({ errmsg, res }) => {
            if (!errmsg) {
              resolve(res);
            } else {
              reject(new Error(errmsg));
            }
          }
        );
      });
    },

    // 加载第三方js
    [LOAD_JS]({ commit, dispatch }, params) {
      return new Promise(resolve => {
        getJSON(params, {}).then(({ errmsg, res }) => {
          resolve();
        });
      });
    },

    // 加载银行汇款价格
    [LOAD_BANK_PRICES]({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        if (state.bankPricesData) {
          resolve(state.bankPricesData);
        } else {
          getJSON(
            STORE_HOST + LOAD_BANK_PRICES_URL,
            gameIdTransform(params)
          ).then(({ errmsg, data }) => {
            if (!errmsg) {
              commit(LOAD_BANK_PRICES, data);
              resolve(data);
            } else {
              reject(new Error(errmsg));
            }
          });
        }
      });
    },

    // 獲取發票信息
    [GET_INVOICE]({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        post(STORE_HOST + GET_INVOICE_URL, gameIdTransform(params), {
          withCredentials: true,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(({ errmsg, res }) => {
          if (!errmsg) {
            resolve(res);
          } else {
            reject(new Error(errmsg));
          }
        });
      });
    },

    [DELETE_CARD]({ state }, params) {
      return new Promise((resolve, reject) => {
        const DELETE_ACTION = params?.f_pay_type + '/del_user_pay_type_infos';
        post(STORE_HOST + DELETE_ACTION, gameIdTransform(params)).then(
          ({ errmsg, res }) => {
            if (!errmsg) {
              resolve(res);
            } else {
              reject(new Error(errmsg));
            }
          }
        );
      });
    },
    [GET_CARD_SCHEMES_ACTION]({ commit }, data) {
      let params = getStoreHrefParam();
      const requestParams = Object.assign(params || {}, data);
      const ACTION = 'credit_card/get_card_schemes';
      return new Promise(resolve => {
        getJSON(STORE_HOST + ACTION, gameIdTransform(requestParams)).then(
          ({ errmsg, res }) => {
            if (!errmsg) {
              commit(SET_CREDIT_CARD_LIST, res.data);
              // 是否有上次选择的记录且记录在当前列表中
              const creditCardRecord = getCreditCardRecord();
              const hasCreditCardRecord =
                creditCardRecord?.length && res.data.includes(creditCardRecord);
              commit(
                SET_CREDIT_CARD,
                hasCreditCardRecord ? creditCardRecord : res.data[0]
              );
              resolve(res);
            } else {
              reject(new Error(errmsg));
            }
          }
        );
      });
    },
    //修改用户第三方支付信息
    [MODIFY_THIRD_PARTY_PAYMENT_INFOS]({ commit }, params) {
      return new Promise((resolve, reject) => {
        post(STORE_HOST + MODIFY_THIRD_PARTY_PAYMENT_INFOS, gameIdTransform(params), {
          withCredentials: true
        }).then(({ errmsg, res }) => {
          if (!errmsg) {
            commit(MODIFY_AREA_LIMIT_INFO, params);
            resolve(res);
          } else {
            reject(new Error(errmsg));
          }
        });
      });
    },
    // 获取支付地区可用币种
    [GET_LOCATION_CURRENCY_LIST]({ commit, state }, params) {
      return new Promise(resolve => {
        getJSON(STORE_HOST + GET_LOCATION_CURRENCY_LIST, gameIdTransform({
          game_id: state.gameId,
          ...params
        })).then(({ res }) => {
          resolve(res);
        });
      });
    },
    // 获取ZipCode列表
    [GET_ZIP_CODE_LIST]({ commit, state }, params) {
      return new Promise(resolve => {
        getJSON(`${STORE_HOST}ajax/` + GET_ZIP_CODE_LIST, {
          state: params.state
        }).then(({ res }) => {
          resolve(res);
        });
      });
    },
    // 获取税率
    [GET_VAT]({ commit, state }, params) {
      return new Promise(resolve => {
        getJSON(`${STORE_HOST}ajax/` + GET_VAT, {
          game_id: state.gameId,
          ...params
        }).then(({ res }) => {
          resolve(res);
        });
      });
    },
  },
  modules: {
    coupon
  }
};
